import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import { withRouter } from 'react-router';
import { HashLink as Link } from 'react-router-hash-link';

//img
import home from '../../assets/icons/home.svg';
import homeContrast from '../../assets/icons/home-white.svg';
import ArrowCircleImg from '../../assets/icons/arrow-circle-empty-medium.svg';
import ArrowCircleImgContrast from '../../assets/icons/arrow-circle-empty-right-contrast.svg';

class HeaderNav extends Component {
	constructor() {
		super();
		this.state = {
			openedId: null
		};
	};

	toggleOpened = (id) => {
		this.setState({ openedId: id });
	};

	resetOpened = () => {
		this.setState({ openedId: null });
	};

	render() {
		const { clang, data } = this.props;
		const { openedId } = this.state;

		return (
			<ul className="header__nav">
				<li className="header__nav-item">
					<NavLink exact to={ `/` } className="header__nav-img__link" title={ lang[ clang ].home } activeClassName="active">
						<img className="header__nav-img" src={ home } alt={ lang[ clang ].alt.home } />
						<img className="header__nav-img contrast" src={ homeContrast } alt={ lang[ clang ].alt.home } />
					</NavLink>
				</li>
				{ data.map(menuItem =>
					<li key={ menuItem.id } className="header__nav-item"
						onMouseEnter={ () => this.toggleOpened(menuItem.id) }
						onMouseLeave={ () => this.resetOpened() }>
						<NavLink to={ `${menuItem.url}` } className="header__nav-item__link" activeClassName="active" title={ menuItem.title }>
							{ menuItem.title }
							<span className="header__nav-item__link-circle"></span>
						</NavLink>
						{ openedId === menuItem.id && menuItem.children &&
							<div className="header__nav-dropdown">
								<h5 className="header__nav-dropdown__title">{ menuItem.title }</h5>
								<ul className="header__nav-dropdown__list">
									{ menuItem.children.map(child =>
										<li key={ child.id } className="header__nav-dropdown__list-item">
											<Link to={ `${child.url}` }
												className="header__nav-dropdown__list-link"
												title={ child.title }
												scroll={ el => el.scrollIntoView({ block: 'start' }) }>
												{ child.title }
												<span className="header__nav-dropdown__list-link__line"></span>
												<img className="header__nav-dropdown__list-link__img" src={ ArrowCircleImg } alt="" />
												<img className="header__nav-dropdown__list-link__img contrast" src={ ArrowCircleImgContrast } alt="" />
											</Link>
										</li>) }
								</ul>
							</div> }
					</li>) }
			</ul>
		);
	};
};


HeaderNav.propTypes = {
	clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
	clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(HeaderNav));



// WEBPACK FOOTER //
// ./src/components/header/HeaderNav.js